import { css, jsx } from '@emotion/react';
import { useRef, useEffect } from 'react';
import { Text } from '../../display/Text/Text.es.js';
import { useInteractiveTagContext } from './InteractiveTagContext.es.js';

const Styles = {
  root: css({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  })
};
const InteractiveTagContent = ({ body, title }) => {
  const contentRef = useRef(null);
  const { setBody, setIsTruncated, setTitle } = useInteractiveTagContext();
  const checkIsTruncated = () => {
    if (contentRef.current) {
      return contentRef.current.scrollWidth > contentRef.current.clientWidth;
    }
    return false;
  };
  useEffect(() => {
    setIsTruncated(checkIsTruncated());
    setBody(body);
    setTitle(title);
  }, []);
  return jsx(
    "div",
    { css: Styles.root, ref: contentRef, "data-zds": true },
    jsx(
      Text,
      { color: "inherit", type: "Body3" },
      title,
      body ? ": " : ""
    ),
    body && jsx(Text, { color: "inherit", type: "Body1" }, body)
  );
};

export { InteractiveTagContent };
//# sourceMappingURL=InteractiveTagContent.es.js.map
